export enum SCHOLARSHIP_STATUS {
  NEW = 0,
  ACCEPTED = 1,
  REJECTED = 2,
  CLOSED = 3,
}
